import clsx from "clsx";
import { Button } from "../buttons/button";

type BottomBarProps = {
	isVisible: boolean;
	onClose: () => void;
	children: React.ReactNode;
};

function BottomBar({ isVisible, onClose, children }: BottomBarProps) {
	const handleClose = () => {
		if (typeof onClose === "function") {
			onClose();
		} else {
			console.warn("onClose is not a valid function.");
		}
	};

	return (
		<div
			className={clsx("z-[50] fixed bottom-0 left-0 flex justify-center w-full transition-transform duration-300 ease-in-out pointer-events-none", {
				"translate-y-0": isVisible,
				"translate-y-full": !isVisible,
			})}
		>
			<div className="flex flex-row w-full max-w-base p-6 pointer-events-auto">
				<div className="flex justify-between items-center w-full p-4 rounded-md bg-background border border-border/50 shadow-lg shadow-black/5">
					<div>{children}</div>
					<Button onClick={handleClose} size="sm" variant="ghost">
						Close
					</Button>
				</div>
			</div>
		</div>
	);
}

export default BottomBar;
